import React from 'react';
import { XCircle, ArrowDown } from 'lucide-react';
import { Button } from './Button';
import { Link } from './Router';

export const PainPoints: React.FC = () => {
  const pains = [
    {
      title: "DER PREISKAMPF TÖTET DICH.",
      description: "Gäste vergleichen nur noch Preise, weil sie den WERT nicht sehen. Du wirst vergleichbar. Dein Angebot wird zur Commodity. Margen sinken.",
      gradient: "from-red-500/20 to-orange-500/20"
    },
    {
      title: "DU HAST PERSONAL-NOTSTAND.",
      description: "Gute Mitarbeiter wollen zu Gewinnern. Wenn deine Brand online aussieht wie von gestern, bewerben sich nur die, die sonst nirgendwo unterkommen.",
      gradient: "from-orange-500/20 to-yellow-500/20"
    },
    {
      title: "UNSICHTBAR AUF SOCIAL MEDIA.",
      description: "Du postest ab und zu ein liebloses Foto. Likes: 3. Reichweite: 0. Deine Zielgruppe scrollt weiter zu deiner Konkurrenz, die den Hype mitnimmt.",
      gradient: "from-gray-800 to-gray-900"
    }
  ];

  return (
    <section className="py-24 bg-brand-dark relative overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-orange/20 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-red-600/10 rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter mb-6">
            Erkennst du <br/><span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-red-500">dich wieder?</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Der Markt ist brutal. Wer stehen bleibt, wird überrollt. Das sind die Realitäten, die wir jeden Tag hören.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {pains.map((pain, index) => (
            <div key={index} className="relative group">
              <div className={`absolute inset-0 bg-gradient-to-br ${pain.gradient} rounded-[2rem] transform group-hover:scale-105 transition-transform duration-500 blur-xl opacity-50`}></div>
              <div className="relative bg-[#1a1a1a] border border-white/10 p-8 rounded-[2rem] h-full hover:-translate-y-2 transition-transform duration-300 flex flex-col">
                <div className="w-12 h-12 bg-red-500/10 rounded-full flex items-center justify-center mb-6">
                  <XCircle className="text-red-500" size={24} />
                </div>
                {/* min-h-[4rem] ensures consistent height approx 2 lines. flex items-end aligns text to bottom of container if needed, or remove for top align */}
                <h3 className="text-2xl font-black text-white mb-4 uppercase min-h-[4rem] flex items-center">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed flex-grow border-t border-white/5 pt-4">
                  {pain.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Agitation / Transition */}
        <div className="text-center flex flex-col items-center">
            <div className="inline-block p-4 rounded-full bg-white/5 border border-white/10 mb-8 animate-bounce">
                <ArrowDown className="text-brand-orange" size={24} />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8">
                Es gibt einen Ausweg. <br/>
                <span className="text-brand-orange">Wir drehen den Spieß um.</span>
            </h3>
            <div className="flex justify-center">
                <Link to="/kontakt">
                    <Button variant="primary" className="text-lg px-10 py-5 shadow-[0_0_30px_rgba(255,103,0,0.4)] hover:shadow-[0_0_50px_rgba(255,103,0,0.6)]">
                        Schluss damit. Jetzt Analyse starten.
                    </Button>
                </Link>
            </div>
        </div>
      </div>
    </section>
  );
};